<template>
  <div class="wtLegend-ctn">
    <span class="wtLegend--icon">
      <slot name="icon"></slot>
    </span>
    <span class="wtLegend--label">
      <slot></slot>
    </span>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'

export default {
  name: 'CLegend',
  mixins: [reDrawTrigger],
  props: {    
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixin';
.wtLegend-ctn {
    display: inline-block;
    .wtLegend--icon, .wtLegend--label {
        display: inline-block;
        position: relative;
    }
    .wtLegend--label {
        color: #485465;
        font-size: $sizeFontSize - 1px;
    }
}
</style>
